import { render, staticRenderFns } from "./SubmittedFormDetailedView.vue?vue&type=template&id=35eb91ca&"
import script from "./SubmittedFormDetailedView.vue?vue&type=script&lang=ts&"
export * from "./SubmittedFormDetailedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports